import {
  headline,
  text,
  field,
  button,
  spacer,
  rank,
} from '@components/Widgets/_contentItems/all'
import themes from '@components/Widgets/Templates/Themes/all'
import { settings, styling } from '@components/Widgets/Templates/_base'
import { position, type } from '@meta/widget/options.js'
import { typeTag, tag } from '@meta/widget/templates.js'

const info = {
  name: 'Let\'s Rate This',
  templateID: '8',
  description:
    'Encourage user interaction and gather ratings with the "Let\'s Rate This" widget. This user-friendly tool lets visitors rate their experience or your content, providing you with instant feedback.',
  tags: [typeTag.FLYOUT, tag.FEEDBACK],
}

const json = {
  id: 45001301,
  templateID: info.templateID,
  type: type.COLUMN,
  name: info.name,
  theme: themes.MONOCHROME,
  active: true,
  settings: (() => {
    const customSettings = { ...settings }
    customSettings.position = position.CENTER
    customSettings.ribbonColor = '#FFFFFF'
    customSettings.animation = 'zoom'
    return customSettings
  })(),
  styling: { ...styling },
  steps: [
    {
      id: 'tkoqun901',
      contentItems: [
        (() => {
          const customHeadline = JSON.parse(JSON.stringify(headline))
          customHeadline.content.text = 'We Value Your Feedback!'
          Object.assign(customHeadline.styling, {
            color: 'rgba(24, 23, 26, 1)',
            fontSize: '28px',
            fontFamily: 'Roboto',
            fontWeight: 'bold',
          })
          return customHeadline
        })(),
        (() => {
          const customText = JSON.parse(JSON.stringify(text))
          customText.content.text = 'How likely are you to recommend our [Product/Service] to a friend or colleague?'
          Object.assign(customText.styling, {
            color: 'rgba(0, 0, 0, 1)',
            fontSize: '14px',
            textAlign: 'left',
            fontFamily: 'Roboto',
          })
          return customText
        })(),
        (() => {
          const customRank = JSON.parse(JSON.stringify(rank))
          customRank.settings.type = 'star'
          customRank.settings.count = 5
          return customRank
        })(),
        (() => {
          const customButton = JSON.parse(JSON.stringify(button))
          customButton.content.text = 'NEXT'
          customButton.settings.backBtn = false
          return customButton
        })(),
      ],
    },
    {
      id: '77h4dne01',
      contentItems: [
        (() => {
          const customHeadline = JSON.parse(JSON.stringify(headline))
          customHeadline.content.text = 'What\'s the primary reason for your score?'
          Object.assign(customHeadline.styling, {
            color: 'rgba(24, 23, 26, 1)',
            textAlign: 'left',
            fontSize: '24px',
            fontFamily: 'Roboto',
            fontWeight: 'bold',
          })
          return customHeadline
        })(),
        (() => {
          const customText = JSON.parse(JSON.stringify(text))
          customText.content.text = 'What aspects of our service led you to give us this rating?'
          Object.assign(customText.styling, {
            color: 'rgba(0, 0, 0, 1)',
            fontSize: '14px',
            textAlign: 'left',
            fontFamily: 'Roboto',
            fontWeight: '400',
          })
          return customText
        })(),
        (() => {
          const customField = JSON.parse(JSON.stringify(field))
          customField.content.placeholder = 'Your message'
          customField.settings.type = 'text'
          Object.assign(customField.styling, {
            color: 'rgba(65, 65, 65, 1)',
            fontSize: '14px',
            textAlign: 'left',
            fontFamily: 'Roboto',
            fontWeight: '400',
            borderColor: 'rgba(81, 81, 81, 1)',
            borderWidth: '1px',
            borderRadius: '0px',
          })
          return customField
        })(),
        (() => {
          const customButton = JSON.parse(JSON.stringify(button))
          customButton.content.text = 'NEXT'
          return customButton
        })(),
      ],
    },
    {
      id: 'ys1h0tp01',
      contentItems: [
        (() => {
          const customHeadline = JSON.parse(JSON.stringify(headline))
          customHeadline.content.text = 'Thank you for taking the time to share your thoughts!'
          Object.assign(customHeadline.styling, {
            fontWeight: 'bold',
            fontSize: '24px',
          })
          return customHeadline
        })(),
        spacer,
      ],
    },
  ],
}

export { json, info }